import { render, staticRenderFns } from "./shops-list.html?vue&type=template&id=57cae134&scoped=true&"
import script from "./shops-list.js?vue&type=script&lang=js&"
export * from "./shops-list.js?vue&type=script&lang=js&"
import style0 from "./shops-list.scss?vue&type=style&index=0&id=57cae134&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cae134",
  null
  
)

export default component.exports